import { MediaType, MediaProtocol, AudioType } from '../appTypings';
import { isServiceId } from './item';
import { Mode } from 'src/common/types';
import { isHbbtvLike } from '../../common/utils';

export const getMediaProtocol = (
  mode: Mode,
  type: MediaType,
  id: string
): MediaProtocol => {
  if (type === AudioType && !isServiceId(id)) return 'pmd';
  if (isHbbtvLike(mode)) return 'dash';
  return 'hls';
};
